"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appLanguageBaseDefault = void 0;
exports.appLanguageBaseDefault = {
    account: 'account',
    add: 'add',
    change: 'change',
    continue: 'continue',
    customize: 'customize',
    refresh: 'refresh',
    darkMode: 'dark mode',
    yourAccountSettings: 'account settings',
    delete: 'delete',
    edit: 'edit',
    freeProduct: 'free',
    invite: 'invite',
    leave: 'leave',
    permanentlyDeleteAccount: "Permanently delete your account",
    permanentlyDeleteWorkspace: "Permanently delete workspace",
    typeTheFollowingToDelete: "Type the following to enable delete",
    markAllread: 'mark all as read',
    name: 'name',
    proProduct: 'pro',
    settings: 'settings',
    signOut: 'sign out',
    toAddMore: 'to add more',
    update: 'update',
    user: 'user',
    users: 'users',
    workspace: 'workspace',
    workspaces: 'workspaces',
    download: 'download',
    file: 'file',
    size: 'size',
    view: 'view',
    uploaded: 'uploaded',
    unknown: 'unknown',
    signIn: 'sign in',
    joiningWorkspaceAtMax: "The workspace you're trying to join is at max capacity.  Please inform the owner and try the invite link again.",
    alreadyJoinedWorkspace: 'You have already joined this workspace.',
    couldNotFindInvitation: 'The invitation could not be found.  It may have been deleted.',
    workspaceAtMaxCapacity: "The current workspace is at max capacity.",
    invalidPromoCode: 'Invalid promo code',
    promoCodeApplied: 'Promo code applied',
    unverified: 'unverified',
};
